import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconLineChart3: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconLineChart3"><Path d="M20.498 20H21.998V4H20.498V20Z" fill="currentColor"/><Path d="M15.832 8V20H14.332V8H15.832Z" fill="currentColor"/><Path d="M8.16602 20H9.66602L9.66602 12H8.16602L8.16602 20Z" fill="currentColor"/><Path d="M3.5 20V16H2V20H3.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconLineChart3;
